/**
 * @generated SignedSource<<a035e39f8fb4615b14493ed3831dc9ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type StoreCustomizations = "DISABLE_HELP";
import { FragmentRefs } from "relay-runtime";
export type TeamHeader_store$data = {
  readonly currentEmployee: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderProfileButton_employee">;
  } | null;
  readonly customizations: ReadonlyArray<StoreCustomizations>;
  readonly dashboards: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"StorecastPickerPopoverDashboards">;
  }>;
  readonly me: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderProfileButton_storeUser">;
  } | null;
  readonly myRole: Roles;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamPickerPopover_store" | "TeamSettingsPopover_Store">;
  readonly " $fragmentType": "TeamHeader_store";
};
export type TeamHeader_store$key = {
  readonly " $data"?: TeamHeader_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "employeeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHeader_store",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamPickerPopover_store"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "myRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customizations",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamSettingsPopover_Store"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "employeeId"
        }
      ],
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "currentEmployee",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamHeaderProfileButton_employee"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreUser",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamHeaderProfileButton_storeUser"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dashboard",
      "kind": "LinkedField",
      "name": "dashboards",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StorecastPickerPopoverDashboards"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "f5c86d71066b7b5be4d83a3136754315";

export default node;
